// Images
import a1 from "../../images/a1.png"
import a2 from "../../images/a2.png"
import a3 from "../../images/a3.png"
import a4 from "../../images/a4.png"
import a5 from "../../images/a5.png"
import a6 from "../../images/a6.png"
import React from 'react';
import tr9 from "../../triangles/tr9.png"
import tr10 from "../../triangles/tr10.png"
import tr11 from "../../triangles/tr11.png"

import tr19 from "../../triangles/tr19.png"
import tr20 from "../../triangles/tr20.png"
import tr21 from "../../triangles/tr21.png"
import tr22 from "../../triangles/tr22.png"
import tr23 from "../../triangles/tr23.png"

// Imports 
import "./Application.scss"
import { Button, Stack, Typography } from "@mui/material";
import { useEffect } from "react";


function Application() {

  useEffect(() => {
    window.scrollTo(0, 0);
} , [])

  return (
    <div className="Application">
      <First />
      <Second />
    </div>
  );
}

function First() {
  if (localStorage.getItem("lang") === "en") {
    return (
    <div className="aFirst">

      <img src={tr9} alt="" className="tr9" />
      <img src={tr10} alt="" className="tr10" />
      <img src={tr11} alt="" className="tr11" />
      
      <div className="container">
        <Typography color="primary" sx={{
          fontWeight: "700",
          fontSize: {xs : "28px" , sm : "44px"},
          lineHeight: "35px",
          textAlign: "center",
          mb : {xs : 0 , sm : 8}
        }}>
          The Lean Finance app is here
        </Typography>
        <Typography color="secondary" sx={{
          fontWeight: "700",
          fontSize: {xs : "28px" , sm : "44px"},
          textAlign: "center",
          lineHeight: "35px",
        }}>
          developed for your success
        </Typography>
      </div>
    </div>
  );
  } else {
    return (
    <div className="aFirst">

      <img src={tr9} alt="" className="tr9" />
      <img src={tr10} alt="" className="tr10" />
      <img src={tr11} alt="" className="tr11" />
      
      <div className="container">
        <Typography color="primary" sx={{
          fontWeight: "700",
          fontSize: {xs : "28px" , sm : "44px"},
          lineHeight: "35px",
          textAlign: "center",
          mb : {xs : 0 , sm : 8}
        }}>
          تطبيق لين فايننس متوفر الآن
        </Typography>
        <Typography color="secondary" sx={{
          fontWeight: "700",
          fontSize: {xs : "28px" , sm : "44px"},
          textAlign: "center",
          lineHeight: "35px",
        }}>
          تم تطويره لنجاحك
        </Typography>
      </div>
    </div>
  );
  }
}

function Second() {
  if(localStorage.getItem("lang") === "en") {
    return (
      <div className="aSecond">
  
        <img src={tr19} alt="" className="tr19" />
        <img src={tr20} alt="" className="tr20" />
        <img src={tr21} alt="" className="tr21" />
        <img src={tr22} alt="" className="tr22" />
        <img src={tr23} alt="" className="tr23" />
        
        <div className="container">
          <Stack spacing={{xs : 30 , sm : 90}}>
            <Stack direction={{xs : "column" , md : "row-reverse"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a1} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  Fast & Simple
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  Issue invoices, credit and <br /> receipt notes in seconds.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>Download now</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a2} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  Quick Invoice
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  maxWidth : "440px",
                  mb : 20
                }}>
                  Instantly initiate your invoice from the Create Invoice button from the side menu.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>Download now</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row-reverse"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a3} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  Easily Share
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  Easily share with clients via <br /> SMS, email, link and WhatsApp.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>Download now</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a4} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  App Security
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  Ensure no one can access the app <br /> but you with fingerprint biometrics.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>Download now</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row-reverse"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a5} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  On The Go
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  Access it anytime <br /> from anywhere.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>Download now</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a6} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  Google / Apple
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  Get the app from the Google Play <br /> and Apple App store.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>Download now</Button>
              </Stack>
            </Stack>
          </Stack>
        </div>
      </div>
    );
  } else {
    return (
      <div className="aSecond">
  
        <img src={tr19} alt="" className="tr19" />
        <img src={tr20} alt="" className="tr20" />
        <img src={tr21} alt="" className="tr21" />
        <img src={tr22} alt="" className="tr22" />
        <img src={tr23} alt="" className="tr23" />
        
        <div className="container">
          <Stack spacing={{xs : 30 , sm : 90}}>
            <Stack direction={{xs : "column" , md : "row-reverse"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a1} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  سريع وبسيط
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  إصدار الفواتير وإشعارات الدائن <br /> والمدين في ثوان.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>تحميل الان</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a2} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  فاتورة سريعة
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  maxWidth : "440px",
                  mb : 20
                }}>
                  ابدأ الفوترة على الفور من زر إنشاء <br /> فاتورة من القائمة الجانبية .
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>تحميل الان</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row-reverse"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a3} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  مشاركة بسهولة
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  شارك بسهولة مع العملاء عبر الرسائل القصيرة  <br />والبريد الإلكتروني والرابط و الواتساب.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>تحميل الان</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a4} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  أمان التطبيق
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  تأكد من عدم تمكن أي شخص من الدخول إلى التطبيق غيرك باستخدام بصمات الأصابع.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>تحميل الان</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row-reverse"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a5} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  أثناء التنقل
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  الدخول إليه في أي وقت <br /> ومن أي مكان.
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>تحميل الان</Button>
              </Stack>
            </Stack>
            <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , sm : 50}} alignItems="center">
              <img src={a6} alt="" />
              <Stack alignItems="center">
                <Typography color="secondary" sx={{
                  fontWeight : "700",
                  fontSize : "30px",
                  lineHeight : "36px",
                  mb : 4
                }}>
                  جوجل / أبل
                </Typography>
                <Typography sx={{
                  fontWeight : "400",
                  fontSize : "24px",
                  lineHeight : "30px",
                  textAlign : "center",
                  mb : 20
                }}>
                  احصل على التطبيق من متجر تطبيقات <br /> بلاي ستور والأبل ستور.
                  
                </Typography>
                <Button href="#footer" variant="contained" sx={{
                  py : 9 , 
                  px : 24,
                  fontSize : "20px",
                  borderRadius : "16px"
                }}>تحميل الان</Button>
              </Stack>
            </Stack>
          </Stack>
        </div>
      </div>
    );
  }
}

export default Application;